import type { Theme } from '@mui/material';
import { alpha } from '@mui/material';

export default function Drawer(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: 'none'
        },
        modal: {
          '&[role="presentation"]': {
            '& .MuiDrawer-paperAnchorLeft': {
              boxShadow: `4px 0 24px 0 ${alpha(theme.palette.grey[900], isLight ? 0.08 : 0.24)}`
            },
            '& .MuiDrawer-paperAnchorRight': {
              boxShadow: `-4px 0 24px 0 ${alpha(theme.palette.grey[900], isLight ? 0.08 : 0.24)}`
            }
          }
        }
      }
    }
  };
}
